import { EllipsisHorizontalCircleIcon } from "@heroicons/react/24/outline";
import {
  BuildingOfficeIcon,
  UserIcon,
  UsersIcon,
} from "@heroicons/react/24/solid";
import React from "react";
import EllipsisDetailsCard from "../EllipsisDetailsCard";
import "./../css/OHOrgChartNode.css";

const OHNSAOrgChartNode = (props) => {
  // Function to determine background color based on title
  const determineColors = (parentId, areaType, districtType) => {
    if (parentId === "") {
      return { backgroundColor: "#ECF9FF", textColor: "#203A75" }; // Color for Chief Sales Officer
    } else if (parentId === "1283") {
      return { backgroundColor: "#ECF9FF", textColor: "#0C77BD" }; // Color for President, Sales
    } else if (areaType === "Area") {
      return { backgroundColor: "#ECF9FF", textColor: "#069EDB" }; // Color for VP, Sales
    } else if (districtType === "District") {
      return { backgroundColor: "#203A75", textColor: "#FFF" }; // Color for District Manager
    }
    // Default color for other titles
    return { backgroundColor: "#fff", textColor: "#000" }; // You can adjust the default text color
  };

  const { backgroundColor, textColor } = determineColors(
    props.node.data.parentId,
    props.node.data.areaType,
    props.node.data.districtType
  );

  //#region Style for download org chart
  const chiefSales = {
    backgroundColor: "#203a75",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
    paddingBottom: "22px",
  };

  const president = {
    backgroundColor: "#0C77BD",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
    paddingBottom: "10px",
  };

  const vicePres = {
    backgroundColor: "#069EDB",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
    paddingBottom: "10px",
  };

  const districtManager = {
    backgroundColor: "#ECF9FF",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
    paddingBottom: "22px",
  };

  const nameEllipsis = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    margin: "5px",
    lineHeight: "30px",
    width: "95%",
    borderRadius: "10px",
    display: "flex",
    backgroundColor: backgroundColor,
    color: textColor,
    marginLeft: "-15px",
    marginTop: "22px",
  };

  const chiefNameEllipsis = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    margin: "5px",
    lineHeight: "30px",
    width: "95%",
    borderRadius: "10px",
    display: "flex",
    backgroundColor: backgroundColor,
    color: textColor,
    marginLeft: "-15px",
    marginTop: "22px",
  };

  const districtCard = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginLeft: "40px",
  };
  const assocCard = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginLeft: "-10px",
    marginTop: "-24px",
    width: "100%",
  };

  const chiefCardEllipsis = {
    right: "45px",
    position: "absolute",
    top: "14px",
    width: "25px",
    marginTop: "12px",
  };

  const cardEllipsis = {
    right: "45px",
    position: "absolute",
    top: "14px",
    width: "25px",
    marginTop: "12px",
  };

  const user = {
    borderRadius: "9999px",
    width: "2rem",
    height: "2rem",
    marginLeft: "-16px",
    color: "#ECF9FF",
  };

  const chiefIconUser = {
    alignSelf: "left",
    right: "270px",
    position: "absolute",
    top: "16px",
    width: "0px",
    borderWidth: "8px",
    borderColor: "#ECF9FF",
    backgroundColor: "#203A75",
    borderRadius: "9999px",
    borderStyle: "solid",
    padding: "1.5rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    height: "33px",
    boxSizing: "unset",
  };

  const iconUser = {
    alignSelf: "left",
    right: "270px",
    position: "absolute",
    top: "16px",
    width: "0px",
    borderWidth: "8px",
    borderColor: "#ECF9FF",
    backgroundColor: textColor,
    borderRadius: "9999px",
    borderStyle: "solid",
    padding: "1.5rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    height: "33px",
    boxSizing: "unset",
  };

  const districtIconUser = {
    alignSelf: "left",
    right: "270px",
    position: "absolute",
    top: "16px",
    width: "0px",
    borderWidth: "8px",
    borderColor: "#ECF9FF",
    backgroundColor: "#203A75",
    borderRadius: "9999px",
    borderStyle: "solid",
    padding: "1.5rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    height: "33px",
    boxSizing: "unset",
  };

  const iconOffice = {
    alignSelf: "left",
    right: "270px",
    position: "absolute",
    top: "-28px",
    width: "0px",
    borderWidth: "8px",
    borderColor: "#ECF9FF",
    backgroundColor: "#203A75",
    borderRadius: "9999px",
    borderStyle: "solid",
    padding: "1.5rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    height: "33px",
    boxSizing: "unset",
  };

  const cardName = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginLeft: "35px",
  };

  const cardNameDistrictH3 = {
    fontSize: "18px",
    cursor: "pointer",
    fontWeight: "bold",
    border: "none",
    textAlign: "center",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    margin: "0",
    color: "white",
  };

  const cardType = {
    height: "auto",
    color: "#fff",
    borderRadius: "30px",
    fontSize: "14px",
    fontWeight: "bold",
    marginLeft: "18px",
  };

  const cardDistrictType = {
    height: "auto",
    color: "#203A75",
    borderRadius: "30px",
    fontSize: "14px",
    fontWeight: "bold",
    marginLeft: "22px",
  };

  const districtCode = {
    alignSelf: "left",
    display: "flex",
    padding: "7px",
    marginLeft: "16px",
    minWidth: "70px",
    height: "auto",
    color: "#203A75",
    borderRadius: "30px",
    fontSize: "14px",
    fontWeight: "bold",
  };

  const region = {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    color: "#203a75",
    borderRadius: "5px 5px 0 0",
    fontSize: "13px",
  };

  const area = {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    color: "#203a75",
    borderRadius: "0",
    fontSize: "13px",
  };

  const territory = {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px",
    color: "#203a75",
    borderRadius: " 5px 5px 0 0",
    fontSize: "13px",
  };

  const code = {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px",
    marginTop: "-34px",
    cursor: "pointer",
    color: "#203a75",
    fontSize: "13px",
  };

  const officeHierarchy = {
    display: "flex",
    padding: "12px",
    paddingLeft: "18px",
    paddingTop: "3px",
    minWidth: "70px",
    height: "auto",
    color: "#fff",
    borderRadius: "30px",
    fontSize: "14px",
  };

  const ellipsis = {
    borderRadius: "9999px",
    width: "1.5rem",
    height: "1.5rem",
  };

  const associatedOffice = {
    backgroundColor: "#fff",
    boxShadow:
      "0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 2px 1px -1px rgb(0 0 0 / 12%)",
    border: "1px solid #203A75",
    borderRadius: "20px",
    cursor: "default",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    paddingTop: "0",
    paddingBottom: "0",
    maxHeight: "500px",
  };

  const cardAssociatedOffice = {
    fontSize: "18px",
    cursor: "pointer",
    fontWeight: "bold",
    border: "none",
    textAlign: "left",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    padding: "15px",
    paddingLeft: "35px",
    backgroundColor: "#203a75",
    borderRadius: "20px",
    color: "white",
    width: "100%",
    boxSizing: "border-box",
  };

  const cardAssociatedOfficeName = {
    fontSize: "12px",
    cursor: "pointer",
    border: "none",
    textAlign: "left",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    margin: "0",
    marginBottom: "10px",
  };

  const cardAssocOfficeName = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginLeft: "10px",
    marginTop: "20px",
  };

  const cardAssocOfficeNameOverFlow = {
    border: "none",
    overflow: "hidden",
    outline: "none",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflowY: "scroll",
    marginTop: "20px",
    marginLeft: "20px",
  };

  const cardNameH3 = {
    fontSize: "18px",
    cursor: "pointer",
    fontWeight: "bold",
    border: "none",
    textAlign: "center",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    margin: "0",
  };
  //#endregion

  return (
    <>
      <div
        className={`${
          props.node.data.id === 1283
            ? `node-card__wrapper chief-sales`
            : props.node.data.territoryType === "Territory" &&
              props.node.data.id !== 1283
            ? `node-card__wrapper president-sales`
            : props.node.data.areaType === "Area"
            ? `node-card__wrapper vp-sales`
            : props.node.data.districtType === "District"
            ? `node-card__wrapper district-manager`
            : props.node.data.type === "Office"
            ? `node-card__wrapper associated-office`
            : ``
        }`}
        style={
          props.node.data.id === 1283
            ? chiefSales
            : props.node.data.territoryType === "Territory" &&
              props.node.data.id !== 1283
            ? president
            : props.node.data.areaType === "Area"
            ? vicePres
            : props.node.data.districtType === "District"
            ? districtManager
            : props.node.data.type === "Office"
            ? associatedOffice
            : ""
        }
      >
        {props.node.data.districtType === "District" ? (
          props.node.data.districtManager !== null ? (
            <div className="node-card__name-ellipsis" style={nameEllipsis}>
              {props.officeHierarchyId === props.node.data.officeHierarchyId
                ? props.cardShow && (
                    <EllipsisDetailsCard
                      userPermission={props.userPermissions}
                      editPermission={props.editPermission}
                      deletePermission={props.deletePermission}
                      nsaChartData={props.nsaChartData}
                    />
                  )
                : ""}
              <div style={districtCard}>
                <div className="node-card__dis">
                  <h3 className="truncate underline" style={cardNameDistrictH3}>
                    {props.node.data.districtManager}
                  </h3>
                </div>
                <div className="text-sm font-base text-gray">
                  {props.node.data.employeeNumber !== ""
                    ? props.node.data.employeeNumber
                    : 0}
                </div>
              </div>
              <div className="node-card__ellipsis" style={cardEllipsis}>
                <EllipsisHorizontalCircleIcon
                  className={`h-6 w-6 rounded-full transition-colors duration-200 hover:text-primary hover:bg-white `}
                  style={{
                    color:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? backgroundColor
                        : "",
                    backgroundColor:
                      props.officeHierarchyId ===
                        props.node.data.officeHierarchyId &&
                      props.isClickedEllipsis
                        ? textColor
                        : "",
                  }}
                />
              </div>
              <div
                className={`rounded-full bg-primary p-6 py-2`}
                style={districtIconUser}
              >
                <UsersIcon
                  className={`text-chartColor rounded-full `}
                  style={user}
                />
              </div>
            </div>
          ) : (
            ""
          )
        ) : props.node.data.type === "Office" ? (
          <>
            <div>
              <div className="node-card__assoc" style={assocCard}>
                <h3 className="truncate" style={cardAssociatedOffice}>
                  Associated Offices
                </h3>

                <div
                  className="rounded-full bg-primary p-6 py-2"
                  style={iconOffice}
                >
                  <BuildingOfficeIcon
                    className={`text-chartColor rounded-full `}
                    style={user}
                  />
                </div>
              </div>
            </div>
            <div
              className="node-card__officeName"
              style={
                props.node.data.associatedOffices.length > 22
                  ? cardAssocOfficeNameOverFlow
                  : cardAssocOfficeName
              }
            >
              <div className="node-card_office">
                {props.node.data.associatedOffices.map((element, index) => (
                  <h3
                    key={index}
                    className="truncate text-quinary underline"
                    style={cardAssociatedOfficeName}
                  >
                    {element.officeName}
                  </h3>
                ))}
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              className={
                props.node.data.id !== 1283
                  ? "node-card__name-ellipsis"
                  : "node-card__chief-name-ellipsis"
              }
              style={
                props.node.data.id !== 1283 ? nameEllipsis : chiefNameEllipsis
              }
            >
              {props.officeHierarchyId === props.node.data.officeHierarchyId
                ? props.cardShow && (
                    <EllipsisDetailsCard
                      userPermission={props.userPermissions}
                      editPermission={props.editPermission}
                      deletePermission={props.deletePermission}
                      nsaChartData={props.nsaChartData}
                    />
                  )
                : ""}
              <div style={cardName}>
                <div className="node-card__name">
                  <h3 className="truncate underline" style={cardNameH3}>
                    {props.node.data.fullName}{" "}
                  </h3>
                </div>
                <div className="text-sm font-base text-gray">
                  {props.node.data.employeeNumber !== ""
                    ? props.node.data.employeeNumber
                    : 0}
                </div>
              </div>
              <div>
                <div
                  className="node-card__ellipsis"
                  style={
                    props.node.data.id !== 1283
                      ? cardEllipsis
                      : chiefCardEllipsis
                  }
                >
                  <EllipsisHorizontalCircleIcon
                    className={`h-6 w-6 rounded-full transition-colors duration-200 hover:text-white hover:bg-primary`}
                    style={{
                      color:
                        props.officeHierarchyId ===
                          props.node.data.officeHierarchyId &&
                        props.isClickedEllipsis
                          ? backgroundColor
                          : "",
                      backgroundColor:
                        props.officeHierarchyId ===
                          props.node.data.officeHierarchyId &&
                        props.isClickedEllipsis
                          ? textColor
                          : "",
                    }}
                  />
                </div>
                <div
                  className="rounded-full bg-primary p-6 py-2"
                  style={props.node.data.id !== 1283 ? iconUser : chiefIconUser}
                >
                  <UserIcon
                    className={`text-chartColor rounded-full `}
                    style={user}
                  />
                </div>
                <div
                  className="rounded-full bg-primary p-6 py-2"
                  style={props.node.data.id !== 1283 ? iconUser : chiefIconUser}
                >
                  <UserIcon
                    className={`text-chartColor rounded-full `}
                    style={user}
                  />
                </div>
              </div>
            </div>
          </>
        )}
        <div
          className="node-card__type"
          style={
            props.node.data.districtType === "District"
              ? cardDistrictType
              : cardType
          }
        >
          {props.node.data.territoryType === "Territory"
            ? props.node.data.territoryManagerTitle
            : props.node.data.areaType === "Area"
            ? props.node.data.areaManagerTitle
            : props.node.data.districtManagerTitle}
        </div>

        {props.node.data.districtType === "District" ? (
          <div
            className="node-card__districtcode underline cursor-pointer"
            style={districtCode}
          >
            {props.node.data.districtType === "District"
              ? props.node.data.districtCode
              : ""}
          </div>
        ) : (
          ""
        )}
        {props.node.data.parentId !== "" ? (
          <>
            {props.node.data.districtType === "District" ? (
              <div className="ml-2 mr-4 rounded-xl bg-white">
                <div>
                  {props.node.data.regionManager !== null ? (
                    <label className={"node-card-dm region"} style={region}>
                      {props.node.data.regionManager}
                    </label>
                  ) : (
                    <label className={"node-card-reg region"} style={region}>
                      Region
                    </label>
                  )}
                  <span
                    className={"node-card_regioncode text-[#203a75]"}
                    style={code}
                  >
                    {props.node.data.regionCode}
                  </span>
                </div>
                <div>
                  <label className={"node-card-dm area"} style={area}>
                    {props.node.data.areaManager !== null
                      ? props.node.data.areaManager
                      : "Area"}
                  </label>
                  <span className={"node-card_areacode"} style={code}>
                    {props.node.data.areaCode}
                  </span>
                </div>
                <div>
                  <label className={"node-card-dm territory"} style={territory}>
                    {props.node.data.territoryManager !== null
                      ? props.node.data.territoryManager
                      : "Territory"}
                  </label>
                  <span className={"node-card_territorycode"} style={code}>
                    {props.node.data.territoryCode}
                  </span>
                </div>
              </div>
            ) : (
              <div
                className="node-card__officeHierarchy cursor-pointer underline"
                style={officeHierarchy}
              >
                {props.node.data.parentId === ""
                  ? ""
                  : props.node.data.territoryType === "Territory"
                  ? props.node.data.territoryCode.replace("-", "") +
                    " - " +
                    props.node.data.name
                  : props.node.data.areaType === "Area"
                  ? props.node.data.areaCode.replace("-", "") +
                    " - " +
                    props.node.data.areaName
                  : ""}
              </div>
            )}
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

OHNSAOrgChartNode.propTypes = {};

export default OHNSAOrgChartNode;
